export default {
  props: {
    job: {
      type: Object,
      default: () => {},
    },
    showExecutors: {
      type: Boolean,
      default: false,
    },
    reportData: {
      type: Object,
      default: () => {},
    },
    executorData: {
      type: Object,
      default: () => {},
    },
  },
};
